import { produce } from 'immer';
import { HouseholdSize, type NonNullableQuiz, type Quiz } from '../defs/quiz';

export function inferHouseholdSizeFromPeopleCount(peopleCount: number) {
  switch (peopleCount) {
    case 0:
      return null;
    case 1:
      return HouseholdSize.ME;
    case 2:
      return HouseholdSize.ME_PLUS_ONE;
    default:
      return HouseholdSize.ME_PLUS_MORE;
  }
}

export function useQuizMutations() {
  return {
    onQuestionAnswer<K extends keyof Quiz>(
      quiz: Quiz,
      question: K,
      value: NonNullableQuiz[K]
    ) {
      return produce(quiz, (draft) => {
        draft[question] = value;
      });
    },
  };
}
